import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Facebook, Instagram, Clock } from "lucide-react";
import { useEffect, useState } from "react";
import { useSettings } from "../../context/SettingsContext";
import { api } from "../../lib/api";

const formatCategory = (code) => {
  if (!code) return "";
  return code.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
};

/* ── Payment card SVGs ──────────────────────────────────────────── */
const VisaCard = () => (
  <div style={{background:"#fff",borderRadius:6,padding:"6px 14px",display:"flex",alignItems:"center",justifyContent:"center",height:40,minWidth:64,boxShadow:"0 1px 3px rgba(0,0,0,0.15)"}}>
    <svg viewBox="0 0 780 500" height="22" xmlns="http://www.w3.org/2000/svg">
      <path d="M293 348.7L339.4 148.5H406.2L359.8 348.7H293Z" fill="#1434CB"/>
      <path d="M557.5 154.3C544.3 149.2 523.7 143.7 497.5 143.7C430.6 143.7 382.8 177.7 382.4 227.3C381.9 263.5 415.5 283.7 440.9 295.7C467.1 308 475.7 316 475.7 327.2C475.4 344.3 453.9 352.1 433.8 352.1C405.7 352.1 390.7 347.9 367.7 338L358.8 333.9L349.2 392.2C365.3 399.2 395.3 405.2 426.3 405.5C497.6 405.5 544.4 372 545 318.9C545.3 289.3 527.1 266.7 485.5 248.1C461.9 236.5 447.5 228.5 447.5 216.4C447.8 205.5 459.5 194.4 485 194.4C506 193.8 521.7 198.6 533.8 203.5L539.6 206.2L549.2 148.5C536 143.8 517.4 138.7 493.5 138.7V154.3H557.5Z" fill="#1434CB"/>
      <path d="M679.4 148.5H626.6C610.4 148.5 598.3 153.1 591.3 169.4L494.3 348.7H565.6L579.4 311.4H665.9L673.9 348.7H737.1L679.4 148.5ZM598.2 263.7C602.4 253 620.2 205.8 620.2 205.8C619.8 206.5 624.3 195 626.8 188.2L630.3 203.9C630.3 203.9 641.3 256.4 643.5 263.7H598.2Z" fill="#1434CB"/>
      <path d="M232.1 148.5L165.7 284.2L158.5 248.9C145.1 204.3 103.1 155.4 55.9 130.3L116.3 348.7H188.2L291.5 148.5H232.1Z" fill="#1434CB"/>
      <path d="M97.1 148.5H-9.5L-10 154.3C45.1 168.3 83.4 195.9 97.1 233.1L82.9 169.7C80.1 153.4 68.8 148.9 57.1 148.5H97.1Z" fill="#EB9900"/>
    </svg>
  </div>
);

const MastercardCard = () => (
  <div style={{background:"#fff",borderRadius:6,padding:"4px 10px",display:"flex",alignItems:"center",justifyContent:"center",height:40,minWidth:64,boxShadow:"0 1px 3px rgba(0,0,0,0.15)"}}>
    <svg viewBox="0 0 131 86" height="28" xmlns="http://www.w3.org/2000/svg">
      <circle cx="47" cy="43" r="37" fill="#EB001B"/>
      <circle cx="84" cy="43" r="37" fill="#F79E1B"/>
      <path d="M65.5 15.7C74.3 22.1 80 32.4 80 43s-5.7 20.9-14.5 27.3C56.7 63.9 51 53.6 51 43s5.7-20.9 14.5-27.3z" fill="#FF5F00"/>
    </svg>
  </div>
);

const StripeCard = () => (
  <div style={{background:"#fff",borderRadius:6,padding:"6px 12px",display:"flex",alignItems:"center",justifyContent:"center",height:40,minWidth:64,boxShadow:"0 1px 3px rgba(0,0,0,0.15)"}}>
    <svg viewBox="0 0 468 222.5" height="20" xmlns="http://www.w3.org/2000/svg">
      <path d="M414 113.4c0-25.6-12.4-45.8-36.1-45.8-23.8 0-38.2 20.2-38.2 45.6 0 30.1 17 45.3 41.4 45.3 11.9 0 20.9-2.7 27.7-6.5v-20c-6.8 3.4-14.6 5.5-24.5 5.5-9.7 0-18.3-3.4-19.4-15.2h48.9c0-1.3.2-6.5.2-8.9zm-49.4-9.5c0-11.3 6.9-16 13.2-16 6.1 0 12.6 4.7 12.6 16h-25.8zM301.1 67.6c-9.8 0-16.1 4.6-19.6 7.8l-1.3-6.2h-22v116.6l25-5.3.1-28.3c3.6 2.6 8.9 6.3 17.7 6.3 17.9 0 34.2-14.4 34.2-46.1-.1-29-16.6-44.8-34.1-44.8zm-6 68.9c-5.9 0-9.4-2.1-11.8-4.7l-.1-37.1c2.6-2.9 6.2-4.9 11.9-4.9 9.1 0 15.4 10.2 15.4 23.3 0 13.4-6.2 23.4-15.4 23.4zM223.8 61.7l25.1-5.4V36l-25.1 5.3zM223.8 69.3h25.1v87.5h-25.1zM196.9 76.4l-1.6-7.1h-21.6v87.5h25V97.5c5.9-7.7 15.9-6.3 19-5.2v-23c-3.2-1.2-14.9-3.4-20.8 7.1zM146.9 46.1l-24.4 5.2-.1 80.1c0 14.8 11.1 25.7 25.9 25.7 8.2 0 14.2-1.5 17.5-3.3V135c-3.2 1.3-19 5.9-19-8.9V90.6h19V69.3h-19l.1-23.2zM79.3 94.7c0-3.9 3.2-5.4 8.4-5.4 7.5 0 17 2.3 24.5 6.4V72.2c-8.2-3.2-16.3-4.6-24.5-4.6C67.5 67.6 54 78.2 54 95.9c0 27.6 38 23.2 38 35.1 0 4.6-4 6.1-9.5 6.1-8.2 0-18.7-3.4-27-7.9v23.6c9.2 4 18.4 5.7 27 5.7 20.6 0 34.8-10.2 34.8-28.1-.1-29.8-38-24.5-38-35.7z" fill="#635BFF"/>
    </svg>
  </div>
);

const BankCard = () => (
  <div style={{background:"#fff",borderRadius:6,padding:"6px 10px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:40,minWidth:64,boxShadow:"0 1px 3px rgba(0,0,0,0.15)"}}>
    <span style={{fontSize:9,fontWeight:700,color:"#374151",textTransform:"uppercase",letterSpacing:"0.05em",lineHeight:1.2,textAlign:"center"}}>Bank<br/>Transfer</span>
  </div>
);

export default function StoreFooter() {
  const { settings } = useSettings();
  const [topCategories, setTopCategories] = useState([]);

  useEffect(() => {
    api.get("/products/facets").then((r) => {
      const cats = (r.data.categories || [])
        .filter((c) => c && c.count > 0)
        .sort((a, b) => b.count - a.count)
        .slice(0, 6)
        .map((c) => ({ label: formatCategory(c.name), href: `/shop?category=${encodeURIComponent(c.name)}` }));
      setTopCategories(cats);
    }).catch(() => {});
  }, []);

  const logo    = settings.logo_url      || "/logo.png";
  const name    = settings.store_name    || "BCP Brisbane Car Parts";
  const phone   = settings.store_phone   || "0406 291 986";
  const phone2  = settings.store_phone_2 || "1800 650 650";
  const email   = settings.store_email   || "sales@bcpcarparts.com.au";
  const address = settings.store_address || "83 Teraba Street, Richlands QLD 4077";
  const hours   = settings.business_hours || "Mon–Fri 8:00–5:30 · Sat 8:00–1:00";

  return (
    <footer className="bg-[#0b1a3b] text-zinc-300 mt-20" data-testid="store-footer">

      {/* ── Main grid ────────────────────────────────────────────────── */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-12 grid grid-cols-1 md:grid-cols-12 gap-10">

        {/* Brand — 3 cols */}
        <div className="md:col-span-3">
          <img src={logo} alt={name}
            className="h-16 w-auto object-contain mb-5 bg-white rounded p-2"
            onError={(e) => { e.target.src = "/logo.png"; }} />
          <p className="text-sm leading-relaxed text-zinc-400 mb-6">
            Brisbane's trusted supplier of quality used car parts.
            30–90 day warranty on selected parts. Australia-wide shipping.
          </p>
          {/* Capricorn badge */}
          <div className="mb-5">
            <img src="/badges/capricorn-preferred-supplier.png" alt="Capricorn Preferred Supplier"
              className="h-14 w-auto object-contain bg-white rounded p-2"
            />
          </div>

        </div>

        {/* Shop — 2 cols */}
        <div className="md:col-span-2">
          <h4 className="font-heading text-[11px] font-bold uppercase tracking-[0.25em] text-[#e31e24] mb-5">Shop Parts</h4>
          <ul className="space-y-3 text-[14px]">
            <li><Link to="/shop" className="hover:text-white transition-colors">All Parts</Link></li>
            {topCategories.map((c) => (
              <li key={c.href}><Link to={c.href} className="hover:text-white transition-colors">{c.label}</Link></li>
            ))}
          </ul>
        </div>

        {/* Company — 2 cols */}
        <div className="md:col-span-2">
          <h4 className="font-heading text-[11px] font-bold uppercase tracking-[0.25em] text-[#e31e24] mb-5">Company</h4>
          <ul className="space-y-3 text-[14px]">
            <li><Link to="/about"             className="hover:text-white transition-colors">About Us</Link></li>
            <li><Link to="/quote"             className="hover:text-white transition-colors">Request a Quote</Link></li>
            <li><Link to="/contact"           className="hover:text-white transition-colors">Contact Us</Link></li>
            <li><Link to="/policies/shipping" className="hover:text-white transition-colors">Shipping Policy</Link></li>
            <li><Link to="/policies/warranty" className="hover:text-white transition-colors">Warranty Policy</Link></li>
            <li><Link to="/policies/refund"   className="hover:text-white transition-colors">Refund Policy</Link></li>
            <li><Link to="/policies/privacy"  className="hover:text-white transition-colors">Privacy Policy</Link></li>
          </ul>
        </div>

        {/* Contact — 3 cols */}
        <div className="md:col-span-3">
          <h4 className="font-heading text-[11px] font-bold uppercase tracking-[0.25em] text-[#e31e24] mb-5">Contact Us</h4>
          <ul className="space-y-4 text-[14px]">
            <li className="flex gap-3">
              <MapPin className="h-5 w-5 text-[#e31e24] shrink-0 mt-0.5" />
              <span>{address}</span>
            </li>
            <li className="flex gap-3">
              <Phone className="h-5 w-5 text-[#e31e24] shrink-0" />
              <a href={`tel:${phone.replace(/\s/g,"")}`} className="hover:text-white transition-colors">{phone}</a>
            </li>
            {phone2 && (
              <li className="flex gap-3">
                <Phone className="h-5 w-5 text-[#e31e24] shrink-0" />
                <a href={`tel:${phone2.replace(/\s/g,"")}`} className="hover:text-white transition-colors">{phone2}</a>
              </li>
            )}
            <li className="flex gap-3">
              <Mail className="h-5 w-5 text-[#e31e24] shrink-0" />
              <a href={`mailto:${email}`} className="hover:text-white transition-colors">{email}</a>
            </li>
            <li className="flex gap-3">
              <Clock className="h-5 w-5 text-[#e31e24] shrink-0 mt-0.5" />
              <span>{hours}</span>
            </li>
          </ul>
        </div>

        {/* Payment — 2 cols */}
        <div className="md:col-span-2">
          <h4 className="font-heading text-[11px] font-bold uppercase tracking-[0.25em] text-[#e31e24] mb-5">Payment Methods</h4>
          <div className="grid grid-cols-2 gap-3 mb-5">
            <VisaCard />
            <MastercardCard />
            <StripeCard />
            <BankCard />
          </div>
                    <div className="flex gap-3">
            <a href="#" aria-label="Facebook"
              className="w-10 h-10 border border-zinc-700 hover:border-[#e31e24] hover:text-[#e31e24] flex items-center justify-center rounded transition-colors">
              <Facebook className="h-4 w-4" />
            </a>
            <a href="#" aria-label="Instagram"
              className="w-10 h-10 border border-zinc-700 hover:border-[#e31e24] hover:text-[#e31e24] flex items-center justify-center rounded transition-colors">
              <Instagram className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>

      {/* ── Bottom copyright bar ──────────────────────────────────────── */}
      <div className="border-t border-zinc-800">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-wrap items-center justify-between gap-3 text-[12px] font-mono text-zinc-500">
          <span>© {new Date().getFullYear()} {name}. All rights reserved.</span>
          <span className="uppercase tracking-[0.2em]">Quality · Warranty · Local Brisbane Support</span>
        </div>
      </div>
    </footer>
  );
}